export default "__VITE_ASSET__671608e1__"